/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs */

const en_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This asset is flagged and should not contribute to portfolio value until reviewed.`)
};

const de_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vermögenswert ist markiert und darf bis zur Überprüfung nicht zum Portfoliowert beitragen.`)
};

const pt_br2_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ativo está sinalizado e não deve contribuir para o valor do portfólio até ser revisado.`)
};

const tr_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu varlık işaretlendi ve incelenene kadar portföy değerine katkıda bulunmamalıdır.`)
};

const zh_cn2_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该资产已被标记，在完成审核前不应计入投资组合价值。`)
};

const zh_hk2_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此資產已被標記，在完成檢視前不應計入投資組合價值。`)
};

const ko_kr2_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 자산은 플래그가 지정되어 있으며, 검토 전까지 포트폴리오 가치에 반영되지 않아야 합니다.`)
};

const ru_ru2_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот актив помечен и не должен учитываться в стоимости портфеля до проверки.`)
};

const es_419_shared_token_warning_blocked_portfolio_description = /** @type {(inputs: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este activo está marcado y no debería contribuir al valor del portafolio hasta que se revise.`)
};

/**
* | output |
* | --- |
* | "This asset is flagged and should not contribute to portfolio value until reviewed." |
*
* @param {Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const shared_token_warning_blocked_portfolio_description = /** @type {((inputs?: Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Token_Warning_Blocked_Portfolio_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "de") return de_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "pt-BR") return pt_br2_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "tr") return tr_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "zh-CN") return zh_cn2_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "zh-HK") return zh_hk2_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "ko-KR") return ko_kr2_shared_token_warning_blocked_portfolio_description(inputs)
	if (locale === "ru-RU") return ru_ru2_shared_token_warning_blocked_portfolio_description(inputs)
	return es_419_shared_token_warning_blocked_portfolio_description(inputs)
});